var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionsLookup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.211,
    height: 43.225,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h41.201v38.288H0z",
    style: {
      stroke: "#707070",
      fill: "none",
      strokeWidth: 2
    },
    transform: "translate(897 145.712)"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".c,.d{fill:none;stroke-width:2px;stroke:#fff}.d{stroke-miterlimit:10}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    },
    transform: "translate(-863.991 -145.712)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M913.339 177.042a14.99 14.99 0 1 0-14.992-14.989 14.994 14.994 0 0 0 14.992 14.989ZM924.47 171.452l12.827 11.547",
    className: "c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.594h27.009M0 26.91h27.009M0 42.225h49.009",
    className: "d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsLookup);
export default __webpack_public_path__ + "static/media/options-lookup.d7ef1f0b90af93bdc727fbe083df18d9.svg";
export { ForwardRef as ReactComponent };